<mat-chip-set *ngIf="formStatuses?.length" aria-label="Statuses" class="small">
  <mat-chip
    class="small status-chip"
    [ngClass]="s.color + '-bg'"
    *ngFor="let s of formStatuses"
  >
    {{ s.name }}
  </mat-chip>
</mat-chip-set>
